const namespace = {
  title: "Market trends",
  noData: "Market trends are not available for this neighborhood at this time.",
  disclaimer: {
    header:
      "Market trend information is based on home transaction data for the previous 12 months and current listing data.",
    footer:
      "Displaying neighborhood trend information for the selected neighborhood. Market Trend information is updated daily.",
  },
  tabs: {
    currentActivity: {
      title: "Current activity",
    },
    recentTrends: {
      title: "Recent trends",
    },
    marketConditions: {
      title: "Market conditions",
    },
  },
  marketIndicator: {
    increase: "increase",
    decrease: "decrease",
    noMonthlyData:
      "{{fieldTitle}} is not available for this neighborhood for the last 30 days.",
  },
  graphs: {
    activeListings: {
      title: "Number of active listings",
      yAxisTitle: "Active listings",
    },
    homesSold: {
      title: "Homes sold",
      disclaimer:
        "The number of residential homes sold over the past 12 months.",
      changeDisclaimer:
        "The percent change in the number of homes sold over the previous 12 months.",
    },
    housingMarketConditions: {
      title: "Housing market conditions",
      subtitle: "An indication of market conditions over time.",
      marketTypes: {
        buyer: "Buyer's market",
        seller: "Seller's market",
        neutral: "Neutral market",
      },
    },
    marketType: {
      title: "Buyer/Seller market",
      disclaimer:
        "Buyer/Seller market indicator is based on the ratio of recent homes sold to new listings.",
      marketTypes: {
        buyer: "Buyer's market",
        seller: "Seller's market",
        neutral: "Neutral market",
      },
    },
    medianAskingPrice: {
      title: "Median asking price",
      disclaimer:
        "The median asking price of residential homes over the past 30 days.",
      changeDisclaimer:
        "The percent change in the median asking price over the previous 30 days.",
    },
    medianConstructionYear: {
      title:
        "The median construction year of homes sold in the past 12 months is ",
    },
    medianDaysOnMarket: {
      title: "Median days on market",
      disclaimer:
        "The median days on market of residential homes over the past 30 days.",
      changeDisclaimer:
        "The percent change in the median days on market over the previous 30 days.",
      yAxisTitle: "Days on market",
    },
    medianSalePrice: {
      title: "Median sales price",
      disclaimer:
        "The median sales price of residential properties over the past 12 months.",
      changeDisclaimer:
        "The percent change in the median sales price over the previous 12 months.",
    },
    medianSalePricePerSqft: {
      title: "Median sales price per square foot",
      disclaimer:
        "The median sales price per square foot of residential properties over the past 12 months.",
      changeDisclaimer:
        "The percent change in the median sales price per square foot over the previous 12 months.",
    },
    medianSaleVsAskingPrice: {
      title: "Median sales vs. asking price of sold homes",
      disclaimer:
        "The median ratio of sold price to asking price of residential homes over the past 30 days.",
      changeDisclaimer:
        "The percent change in the ratio of sales price to asking price of residential homes over the last 30 days.",
    },
  },
} as const;

export default namespace;
